import Make from './../components/MakeSection/Make';
import FAQs from '../components/FAQsSection/FAQs';
import ServicesSection from '../components/ServicesSection/ServicesSection';
import History from '../components/HistorySection/History';
import Description from '../components/DescriptionSection/Description';
import HeroSection from '../components/HeroSection/HeroSection';
import SEO from '../components/SEO/SEO';
import { usePageSEO } from '../hooks/usePageSEO';

const B2C = () => {
  const seo = usePageSEO('b2c');

  return (
    <>
      <SEO
        title={seo.title}
        description={seo.description}
        keywords={seo.keywords}
        type={seo.type}
        noIndex={seo.noIndex}
        noFollow={seo.noFollow}
      />
      <HeroSection page="B2CPage" showRecentWork={false} showMoreButton={true} />
      <ServicesSection page="B2CPage" />
      <History pageKey="B2CPage" />
      <Description page="B2CPage" />
      <FAQs page='b2cPage' />
      <Make pageKey='b2cPage' />
    </>
  );
};

export default B2C;